const qabUploadedSvg = (state: AnyFixMe, compId: AnyFixMe) =>
  state.mobile.qab[compId];

const isEnabled = (state: AnyFixMe) => state.mobile.qab.enabled;

export { qabUploadedSvg, isEnabled };
